import { IFieldSchema } from "./IFieldSchema";
import CControl from "./CControl";
import { CForm } from "./JSForm";
import { isNullOrEmpty } from "@ioip/core/lib";

export interface ICTextFieldProps {
    form: CForm;
    schema: IFieldSchema;
}

class CTextField extends CControl {

    #props: ICTextFieldProps;

    constructor(props: ICTextFieldProps) {
        super({ form: props.form, schema: props.schema });
        this.#props = props;
    }

    get label(): string {
        return this.#props.schema.label;
    }

    get maxLength(): number {
        return this.#props.schema.maxLength || 0;
    }

    get minLength(): number {
        return this.#props.schema.minLength || 0;
    }

    get required(): boolean {
        return this.#props.schema.required;
    }

    get placeholder(): string {
        return this.#props.schema.placeholder;
    }

    get multiline(): boolean {
        return this.#props.schema.multiline;
    }

    validate(): boolean {

        this.errorMessage = null;
        const hasValue = !isNullOrEmpty(this.value as any);

        // Check required
        if (this.required) {
            if (!hasValue) {
                this.errorMessage = 'Campo requerido';
                return false;
            }
        }

        // Check min length
        // if (this.minLength > 0 && hasValue) {
        //     if (this.value.length < this.minLength) {
        //         this.errorMessage = `El valor debe tener al menos ${this.minLength} caracteres`;
        //         return false;
        //     }
        // }

        // Check max length
        // if (this.maxLength > 0 && hasValue) {
        //     if (this.value.length > this.maxLength) {
        //         this.errorMessage = `El valor debe tener como máximo ${this.maxLength} caracteres`;
        //         return false;
        //     }
        // }

        return true;
    }

}

export default CTextField;